import React from 'react'
import Collection from '../common/collection'

function CollectionD({ props }) {
  return (
    <Collection
      alt="Parvada"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas14.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas16.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas17.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas54.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas55.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/4.+parvadas56.jpg',
      ]}
    />
  )
}


export default CollectionD
